import { IsMediaAllowed } from './types';

// By default redeem in restaurant is allowed in mobile devices only
export const isMediaAllowed: IsMediaAllowed = ({ isMobile }) => isMobile;
